// 运营文字上限，口径与后端 backend/index.mjs 的 AGENT_TEXT_LIMIT / textLen 一致，改一处要两处一起改。
// 后端才是真正的拦截，这里只负责提前提示，免得运营打完一大段才被拒。
// 2026-10-05 定 50 字，2026-10-06 改成 70，跟快捷话术 QUICK_REPLY_LIMIT 一致
export const TEXT_LIMIT = 70
// 个人快捷话术上限，跟后端 QUICK_REPLY_LIMIT 一致；系统共享话术不限字数（2026-10-09）。
export const QUICK_REPLY_LIMIT = 70

// 去掉空白后按码点计数（emoji 算 1 个）
export const textLen = (s) => [...String(s || '').replace(/\s/g, '')].length

// 下面两个跟后端 backend/text.mjs 是同一套口径，改一处要两处一起改（后端才是真正的拦截）。
// 「只是删减」：sent 去掉空白后的字符按顺序都能在 source 里找到，且不比 source 长。
export const isDeletionOf = (sent, source) => {
  const a = [...String(sent || '').replace(/\s/g, '')]
  const b = [...String(source || '').replace(/\s/g, '')]
  if (!a.length || !b.length || a.length > b.length) return false
  let i = 0
  for (const ch of b) {
    if (ch === a[i]) i++
    if (i === a.length) return true
  }
  return i === a.length
}

// 运营这一条能不能发：人工输入不超过 limit 字；系统话术（共享话术，agent_id 为空）删减后可以超过。
// 2026-10-12 Gavin 定：用系统话术时不按输入框 70 字限制，只能减少不能增加。
export const isAgentTextAllowed = (content, limit, sharedReplies = []) =>
  textLen(content) <= limit ||
  sharedReplies.some(r => r?.content && isDeletionOf(content, r.content))

// 企微 48 小时 / 5 条的额度按客户算、要跨会话，前端算不全，改由后端 getSendQuota 给
